module.exports = __webpack_public_path__ + "static/img/Scarlet.c125177.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/carousel/Scarlet.jpg
// module id = n0PJ
// module chunks = 1